import {
  CUSTOM_SIGNUP_FETCH_DETAILS_REQUEST,
  CUSTOM_SIGNUP_FETCH_DETAILS_SUCCESS,
  CUSTOM_SIGNUP_FETCH_DETAILS_FAILURE,
  CUSTOM_SIGNUP_RESET_DETAILS,
} from '../../constants/ActionTypes';

const customSignup = (
  state = {
    isFetching: false,
    details: {},
    updatedAt: Date(),
  },
  action
) => {
  switch (action.type) {
    case CUSTOM_SIGNUP_FETCH_DETAILS_REQUEST:
      return { ...state, isFetching: true };
    case CUSTOM_SIGNUP_FETCH_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.data,
        updatedAt: Date(),
        isFetching: false,
      };
    case CUSTOM_SIGNUP_FETCH_DETAILS_FAILURE:
    case CUSTOM_SIGNUP_RESET_DETAILS:
      return { ...state, details: {}, updatedAt: Date(), isFetching: false };
    default:
      return state;
  }
};

export default customSignup;
